import React from "react";
import TokenService from "../utility";

type Props = {
  roleReqiured: string[];
  message: string;
  children: React.ReactNode;
};
const useRole = () => {
  const user = TokenService.getTokenUser();
  if (user)
    if (user.is_superuser) return "ADMIN";
    else if (user.is_staff) return "STAFF";
    else return "USER";
  else return "USER";
};

const WithPermission = (props: Props) => {
  const { roleReqiured, message, children } = props;
  const role = useRole();
  return (
    <>
      {roleReqiured.includes(role) ? (
        children
      ) : (
        <h2> {message ? message : ""}</h2>
      )}
      .
    </>
  );
};

export default WithPermission;
